module.exports = ".select-atento deep mat-form-field span {\n  color: black !important; }\n\n.impr-lbl-ayuda-container {\n  margin-top: 16px; }\n"